import { useKeyCloak } from '@/hooks/useKeyCloak'

import { Box } from '@chakra-ui/react'
import { LayoutGroup } from 'framer-motion'

import { Notifications } from '@/features/notification'
import { ProductMessageBanner } from '@/features/product-messages'
import { StaleWork } from '@/features/stale-work'
import { MicPermissionBanner } from '@/features/system-banners'

interface AppLayoutIProps {
  children?: React.ReactNode
}

export const AppLayout = ({ children }: AppLayoutIProps) => {
  const { isValidLogin } = useKeyCloak()

  return (
    <Box display='flex' flexDirection='column' h='100vh'>
      <Notifications />
      {/*
        This layout renders above the `requireAuth` page gate, so anything in
        it is live during the window between app mount and the Keycloak login
        redirect navigating the document away. The banners are gated here as a
        group rather than one at a time: the mic banner is only the one that
        surfaced it (ENG-34127), because its state comes from a local browser
        API with no network call, while the data-driven banners happen to stay
        empty today. A cached response or a future client-side banner would
        flash the same way, so no banner renders before the session is valid.
      */}
      {isValidLogin && (
        <>
          <ProductMessageBanner />
          <StaleWork />
          <MicPermissionBanner />
        </>
      )}
      <Box flex={1} minH={0}>
        <LayoutGroup>{children}</LayoutGroup>
      </Box>
    </Box>
  )
}
